import React, { Component } from 'react'
import AppRouter from './components/AppRouter'
import 'iframe-resizer/js/iframeResizer.contentWindow.min'
import 'blt-react-dates/initialize'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import './App.scss'
import 'blt-react-dates/lib/css/_datepicker.css'
import moment from 'moment'

moment.locale('es')

class App extends Component {
  render () {
    return (
      <AppRouter />
    )
  }
}

export default App
